module.exports = "/_next/static/images/5c993e1b9156ac9677ed63f2968046aa-defer-lg.png.webp";